// A single set of stage labels shared across the client dashboard, job list and documents.
export const displayNumber = job => /^B0T\d{5}$/.test(job?.workOrderNumber || '')
  ? job.workOrderNumber : 'Assigning reference…';

export function formatDate(value) {
  if (!value) return '';
  let date;
  try {
    if (typeof value.toDate === 'function') date = value.toDate();
    else if (typeof value.seconds === 'number') date = new Date(value.seconds * 1000);
    else if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) date = new Date(`${value}T12:00:00`);
    else date = new Date(value);
  } catch { return ''; }
  return date instanceof Date && !Number.isNaN(date.getTime())
    ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '';
}

export function formatMoney(cents) {
  return Number.isFinite(cents)
    ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100)
    : null;
}

export function remainingCents(job) {
  if (job.finalPaymentPaid === true) return 0;
  const quote = job.quote;
  if (!quote || !Number.isFinite(quote.totalCents)) return 0; // Unquoted is not a debt.
  const deposit = job.depositPaid === true ? Number(quote.depositCents || 0) : 0;
  return Math.max(0, quote.totalCents - deposit);
}

export function jobStage(job) {
  const status = job.status || 'pending';
  const paid = job.finalPaymentPaid === true || job.paid === true;
  if (status === 'cancelled') return { group:'closed', label:'Cancelled', description:'This request was cancelled.' };
  if (status === 'quote_sent' && job.quote?.status === 'sent') return { group:'attention', label:'Quote ready', action:'Review quote', description:'Review your proposed scope and price.' };
  if (status === 'pending_payment' && job.depositPaid !== true) return { group:'attention', label:'Deposit due', action:'Pay deposit', description:'Pay the deposit to continue.' };
  if (status === 'completed' && !job.clientApproval?.approved) return { group:'attention', label:'Review work', action:'Review completed work', description:'Your service report is ready for approval.' };
  if (status === 'completed' && job.clientApproval?.approved && !paid && remainingCents(job) > 0) return { group:'attention', label:'Balance due', action:'Pay remaining balance', description:'Your final invoice is ready.' };
  if (status === 'completed' && paid) return { group:'closed', label:'Paid in full', description:'Your service and payment are complete.' };
  if (status === 'completed') return { group:'closed', label:'Completed', description:'Your service has been completed.' };
  if (status === 'scheduled') return { group:'active', label:'Scheduled', description:'Your appointment is confirmed.' };
  if (status === 'in-progress') return { group:'active', label:'Work in progress', description:'Your technician is working on this job.' };
  if (status === 'pending_review') return { group:'active', label:'Report review', description:'Chuko Logic is reviewing the service report.' };
  if (status === 'deposit_paid') return { group:'active', label:'Scheduling', description:'Your deposit is verified; scheduling is next.' };
  if (status === 'quote_ready') return { group:'active', label:'Preparing quote', description:'A revised quote is being prepared.' };
  return { group:'active', label:'Request received', description:'We are reviewing your service request.' };
}

export const stageTone = {
  attention:'border-amber-200 bg-amber-50 text-amber-900',
  active:'border-[#cfe0f5] bg-[#eef5ff] text-[#245f9d]',
  closed:'border-emerald-200 bg-emerald-50 text-emerald-800',
};
